<template>
  <div class="download">
    <img src="	http://vmuyun.com/static/img/u970.6cdcb35.svg" alt="" />
    <!-- <div>手机扫描二维码下载<1/div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
.download {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  font-size: 1.2vw;
  box-sizing: border-box;
  padding-top: 5%;
}
.download img {
  width: 100%;
  height: 100%;
}
.pasture {
  width: 31.5vw;
  background: linear-gradient(180deg, #0e213e 0%, #10141b 100%);
  padding-bottom: 1.2vw;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  border: 1px solid #1d5fd1;
}

.pasture-title {
  height: 2vw;
  line-height: 2vw;
  text-align: center;
  background: linear-gradient(94deg, rgba(22, 95, 203, 0) 4%, #165fcb 52%, rgba(22, 95, 203, 0) 100%);
  opacity: 1;
  position: relative;
}

.pasture-exit {
  width: 1.2vw;
  height: 1.2vw;
  background: url('../SmartLivestock-zzry/map/img/exit.png');
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/downloadImg.vue